import { useCallback } from 'react';

import { isMobile } from '@growtherapy/analytics';

import { useOnInactiveScreenDetected } from './useOnInactiveScreenDetected';

export const useOnInactiveMobileScreenDetected = (onLeaveCallback: () => void, onReturnCallback?: () => void) => {
  const handleLeaveCallback = useCallback(() => {
    if (!isMobile(navigator.userAgent)) return;

    onLeaveCallback();
  }, [onLeaveCallback]);

  const handleReturnCallback = useCallback(() => {
    if (!isMobile(navigator.userAgent)) return;

    onReturnCallback?.();
  }, [onReturnCallback]);

  useOnInactiveScreenDetected(handleLeaveCallback, handleReturnCallback);
};
